export default __webpack_public_path__ + "static/media/not-found-map-filters.eff6ffb2.svg";